// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_GO_TO_CHARTS = "Rebr\u00ed\u010dky";
export const STROLLERS_HOME_ALL_BRANDS = "V\u0161etky zna\u010dky ko\u010d\u00edkov";
export const STROLLERS_HOME_BRANDS_count = ["%(count)s zna\u010dka", "%(count)s zna\u010dky", "%(count)s zna\u010diek"];
export const STROLLERS_HOME_POPULAR_BRANDS = "Popul\u00e1rne zna\u010dky";
